export const clientEndpoint = {
	enquete: "/enquete",
	template: "/template",
} as const;

export const editorEndpoint = {
	create: "create",
	edit: "edit",
} as const;
